<template>
  <form ref="emergencyForm">
    <div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

        <div>
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Name
          </label>
          <input
            v-model="form.emerName"
            type="text"
            placeholder="Enter name"
            required
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
          />
        </div>

        <div class="md:col-span-2">
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Address
          </label>
          <input
            v-model="form.emerAddress"
            type="text"
            placeholder="Enter address"
            required
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Mobile Number
          </label>
          <input
            v-model="form.emerCellphoneno"
            type="tel"
            placeholder="e.g. +63 987 654 3210"
            required
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { toRefs } from "vue";

export default {
  name: "InCaseEmergency",
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { formData: form } = toRefs(props);
    return { form };
  },
};
</script>
